import React, {useEffect, useState} from "react";
import PageHeader from "../../Elements/PageHeader";
import {useLocation, useParams} from "react-router-dom";
import {IRouteParams} from "../../../contracts/router";
import useQuery from "../../../hook/useQuery";
import {isNotEmpty} from "../../../helpers/functions";
import httpClient from "../../../services/httpClient";
import {ticketsApi} from "../../../constans/apiUrls";
import Loading from "../../Elements/Loading/Loading";
import {RouterStateSectionType, TicketStatusType} from "../../../constans/enumTypes";
import MyModal from "../../Elements/MyModal";
import {useAppDispatch} from "../../../hook/useAppDispatch";
import {fetchUserInfo} from "../../../store/userStore";
import {IRouterListToData} from "../../../contracts/data/router";
import {ITicketData, ITicketReplayData} from "../../../contracts/data/ticket";
import TicketReplyCard from "./TicketReplyCard";
import ReplyTicketForm from "../../../forms/dashboard/ticket/ReplyTicketForm";

const DetailsTicket: React.FC = () => {
    const params: IRouteParams = useParams();
    const queryParams = useQuery();
    const location = useLocation<IRouterListToData>()
    const [data, setData] = useState<ITicketData>()
    const [ticket, setTicket] = useState<ITicketReplayData>()
    const [loading, setLoading] = useState<boolean>(true)
    const [showReply, setShowReply] = useState<boolean>(false)
    const dispatch = useAppDispatch()

    const handleFetchData = async () => {
        await httpClient().get(`${ticketsApi.update}/${queryParams.get('id')}`)
            .then(response => {
                if (response.status === 200) {
                    setData(response?.data?.data)
                    setTicket({
                        id: response?.data?.data?.id,
                        user: response?.data?.data?.user,
                        user_type: response?.data?.data?.user_type,
                        content: response?.data?.data?.content,
                        attachment: response?.data?.data?.attachment,
                        created_time_jalali: response?.data?.data?.created_time_jalali,
                        modified_time_jalali: response?.data?.data?.created_time_jalali,
                    })
                }
            })
            .catch(error => console.log(error))
            .finally(() => setLoading(false))
    }

    const handleSubmitReplyForm = (newReply: ITicketReplayData) => {
        let ticketTemp: ITicketData = data!
        if (ticketTemp.status === TicketStatusType.CHECK || ticketTemp.status === TicketStatusType.QUESTION) {
            dispatch(fetchUserInfo())
        }
        ticketTemp?.replies?.unshift(newReply)
        setData(ticketTemp)
    }

    useEffect(() => {
        handleFetchData()
    }, [])

    const ticketRepliesList = data?.replies?.map((item, index) => <TicketReplyCard key={`reply-${index}`} data={item}/>)

    return (
        <React.Fragment>
            <PageHeader title={`جزییات تیکت ${isNotEmpty(queryParams.get('code')) ? queryParams.get('code') : ""}`}
                        isBackBtn
                        urlBackBtn={`${location?.state?.page}?page_num=${location?.state?.page_num}${location?.state?.section === RouterStateSectionType.USER ? "&id=" + location?.state?.userId : ""}&name=${queryParams.get('name')}`}
                        isFirstBtn={true} firstBtnTitle={"پاسخ تیکت"}
                        handlerFirstBtn={() => setShowReply(true)}
            />
            <div>
                {loading ? <Loading/> :
                    <>
                        <MyModal isOpen={showReply} title={"پاسخ تیکت"} btnSecondaryTxt={"بستن"}
                                 handlerSecondaryButton={() => setShowReply(false)}>
                            <ReplyTicketForm ticketId={parseInt(queryParams.get('id')!)}
                                             handlerInsertReply={(value: ITicketReplayData) => {
                                                 handleSubmitReplyForm(value)
                                                 setShowReply(false)
                                             }}/>
                        </MyModal>
                        {data?.replies?.length! > 0 ? ticketRepliesList : null}
                        {ticket && <TicketReplyCard key={0} data={ticket}/>}
                    </>
                }
            </div>
        </React.Fragment>
    )
}

export default DetailsTicket